import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import classes from './SubscriptionPopup.module.css';

const SubscriptionPopup = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: '20px',
        },
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '1px solid #e0e0e0'
      }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
          Subscription Required
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: '#666' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: '24px 0' }}>
        <Box sx={{ textAlign: 'center', marginBottom: '24px' }}>
          <Box
            sx={{
              width: '80px',
              height: '80px',
              backgroundColor: '#f0f4ff',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: '#3D4BD6',
                fontWeight: 'bold',
              }}
            >
              🔒
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            marginBottom: '16px',
            fontWeight: 600,
            color: '#333',
          }}
        >
          Advanced Onboarding Feature
        </Typography>

        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: '#666',
            lineHeight: 1.6,
            marginBottom: '24px',
          }}
        >
          You need to subscribe to a license to use the advanced onboarding service. 
          This feature includes enhanced verification, document processing, and automated workflows.
        </Typography>

        <Box
          sx={{
            backgroundColor: '#f8f9fa',
            padding: '16px',
            borderRadius: '8px',
            marginBottom: '24px',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              textAlign: 'center',
              fontStyle: 'italic',
            }}
          >
            Contact our sales team to upgrade your account and unlock advanced features.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: '0 0 20px 0', justifyContent: 'center' }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: '#3D4BD6',
            color: 'white',
            padding: '12px 32px',
            borderRadius: '8px',
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#2c3aa8',
            },
          }}
        >
          Contact Sales
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionPopup;
